import { render, staticRenderFns } from "./SupportContactModal.vue?vue&type=template&id=1d3ea80e&scoped=true&"
import script from "./SupportContactModal.vue?vue&type=script&lang=js&"
export * from "./SupportContactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3ea80e",
  null
  
)

export default component.exports